import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { SetLoading } from 'src/app/shared/store/shared.actions';
import { UnsubscribeAction } from '../store/auth.actions';
import { LocalStorageService } from 'src/app/shared/localstorage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss'],
})
export class UnsubscribeComponent implements OnInit {
  constructor(
    private router: Router,
    private readonly store: Store<AppState>,
    private activateRoute: ActivatedRoute,
    private translateService: TranslateService
  ) {}

  contact_id: number | undefined;
  email = '';

  ngOnInit() {
    const lang = this.activateRoute.snapshot.queryParamMap.get('lang');
    if (lang) {
      this.translateService.use(lang.split('_')[0]);
    }

    const contact_id = this.activateRoute.snapshot.queryParamMap.get('id');
    if (contact_id) {
      this.contact_id = parseInt(contact_id);
    }
    this.email = this.activateRoute.snapshot.paramMap.get('email')!;
    const currentUser = LocalStorageService.get('currentUser');
    if (this.email !== currentUser?.contact.email) {
      LocalStorageService.put('currentUser', {});
      this.router.navigate([''], { queryParams: { next: this.router.url } });
    }
  }

  onUnsubscribe() {
    if (this.contact_id) {
      this.store.dispatch(SetLoading({ isAppLoading: true }));
      this.store.dispatch(UnsubscribeAction({ contact_id: this.contact_id }));
    }
  }

  goHome() {
    this.router.navigate(['/pages/catalogs']);
  }
}
